<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick">
      <Avatar :src="userAvator" />
      <!-- <DropdownMenu slot="list"> -->
      <!-- <DropdownItem name="personalCenter">个人中心</DropdownItem> -->
      <!-- <DropdownItem name="logout">退出登录</DropdownItem> -->
      <!-- </DropdownMenu> -->
    </Dropdown>
  </div>
</template>

<script>
import { logout } from '@/api/user';
import Cookies from 'js-cookie';

export default {
  name: 'HeaderAvatar',
  props: {
    userAvator: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClick(name) {
      if (name === 'personalCenter') {
        this.$router.push({
          name: 'personalCenter',
        });
      } else if (name === 'logout') {
        // 退出登录
        logout().then((data) => {
          if (data) {
            Cookies.remove('user');
            localStorage.removeItem('userInfo');
            this.$router.push({
              name: 'login',
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.user-avator-dropdown {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
}
</style>
